import React from "react";

import {
  Root,
  Header,
  Logo,
  MenuButton,
  Container,
  MenuContainer,
  Link,
  FooterContainer,
  SocialContainer,
  SocialLink,
} from "./MobileMenu.style";

import useLockBodyScroll from "../../../hooks/useLockBodyScroll";

import logoSrc from "../../assets/logo.png";
import instagramSrc from "../../assets/icon-instagram.svg";
import facebookSrc from "../../assets/icon-facebook.svg";
import youtubeSrc from "../../assets/icon-youtube.svg";

import { Counter } from "../../Counter/Counter";
import { Button } from "../../Button/Button";

export const MobileMenu = ({ onClose, onEntryShow }) => {
  useLockBodyScroll();

  return (
    <Root>
      <Counter variant="mobile-menu" />
      <Header>
        <Logo src={logoSrc} alt="Ole Smoky Moonshine logo" />
        <MenuButton type="button" onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width={48}
          >
            <path
              fill="currentColor"
              d="M38.562 36.438a1.512 1.512 0 0 1 .325 1.636 1.512 1.512 0 0 1-.812.812 1.493 1.493 0 0 1-1.149 0 1.496 1.496 0 0 1-.487-.325L24 26.12 11.562 38.561a1.505 1.505 0 0 1-2.123 0 1.504 1.504 0 0 1 0-2.123L21.88 24 9.439 11.561a1.504 1.504 0 0 1 0-2.123 1.5 1.5 0 0 1 2.123 0L24 21.879 36.439 9.438a1.503 1.503 0 0 1 2.562 1.062c0 .398-.158.779-.439 1.061L26.121 24l12.441 12.438Z"
            />
          </svg>
        </MenuButton>
      </Header>

      <Container>
        <MenuContainer className="--mobile">
          <Link
            to="home"
            duration={150}
            spy={true}
            activeClass="--active"
            onClick={onClose}
          >
            Home
          </Link>
          <Link
            to="prizes"
            duration={150}
            spy={true}
            activeClass="--active"
            onClick={onClose}
          >
            Prizes
          </Link>
          <Link
            to="cocktails"
            duration={150}
            spy={true}
            activeClass="--active"
            onClick={onClose}
          >
            Cocktails
          </Link>
          <Link
            to="merch"
            duration={150}
            spy={true}
            activeClass="--active"
            onClick={onClose}
          >
            Merch
          </Link>
        </MenuContainer>

        <FooterContainer>
          <Button
            type="button"
            style={{ width: "fit-content" }}
            onClick={onEntryShow}
          >
            enter for a chance to win
          </Button>
          <SocialContainer>
            <SocialLink
              target="_blank"
              href="https://www.instagram.com/olesmoky/?hl=en"
            >
              <img src={instagramSrc} alt="instagram" />
            </SocialLink>
            <SocialLink
              target="_blank"
              href="https://www.facebook.com/olesmoky"
            >
              <img src={facebookSrc} alt="facebook" />
            </SocialLink>
            <SocialLink
              target="_blank"
              href="https://www.youtube.com/channel/UCHiz5-YT3yX0VqkfGKKy3zw"
            >
              <img src={youtubeSrc} alt="youtube" />
            </SocialLink>
          </SocialContainer>
        </FooterContainer>
      </Container>
    </Root>
  );
};
